export const backendUrl = import.meta.env.VITE_BACKEND_URL || 'https://api.getbloom.app';
// export const backendUrl = 'http://192.168.40.76:8000';

/**
 * MCP API key for real-time price endpoint authentication.
 * Required for subscribed users to access real-time price updates.
 *
 * To generate an API key:
 * 1. Create an MCPAPIKey in Django admin or via management command
 * 2. Set VITE_REALTIME_API_TOKEN in frontend/.env
 *
 * Note: Real-time prices are only available to subscribed users.
 * Non-subscribed users will not fetch prices even if token is provided.
 */
export const realtimeApiToken = import.meta.env.VITE_REALTIME_API_TOKEN || '';
export const discordInviteUrl = 'https://discord.gg/w2Pud2D4Ts';
export const appStoreUrl = 'https://apps.apple.com/us/app/bloom-stock-market-research/id1436348671';
export const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.bloom.invest';
